@if (!(hideWhenEmpty() && teamList.length === 0)) {
  <p-select
    [options]="teamList"
    [multiple]="true"
    [filter]="true"
    filterBy="label"
    [disabled]="disabled()"
    [ngModel]="teams"
    (ngModelChange)="teams = $event; onTeamChange($event)"
    appendTo="body"
    panelStyleClass="p-select-checkbox-options"
    [placeholder]="placeholder()"
    [lazy]="true"
    dataKey="id"
  >
    <ng-template #item let-option>
      <p-checkbox
        [ngModel]="isSelected(option.value)"
        [binary]="true"
        [disabled]="option.disabled"
        [readonly]="true"
        [tabindex]="-1"
      />
      <span>{{ option.label }}</span>
    </ng-template>

    <ng-template #selectedItem>
      <app-selected-chips
        [items]="teams"
        [label]="chipLabel"
        [key]="chipKey"
        [removable]="!disabled()"
        (removeItem)="removeTeam($event)"
      />
    </ng-template>
  </p-select>
}
